document.addEventListener('DOMContentLoaded', function() {
  const toggleBtn = document.getElementById('toggleBtn');
  const descriptionContent = document.getElementById('collectionDescription');
  
  if (!toggleBtn || !descriptionContent) return;
  
  const mobileCharLimit = 300;
  const mobileBreakpoint = 768;
  
  // Translation detection
  const lang = document.documentElement.lang || 'en';
  const translations = {
    en: { showMore: 'Show More', showLess: 'Show Less' },
    fr: { showMore: 'Voir plus', showLess: 'Voir moins' }
  };
  const t = translations[lang] || translations.en;
  
  let isExpanded = false;
  let originalContent = descriptionContent.innerHTML;
  let textContent = descriptionContent.textContent || descriptionContent.innerText;
  
  function truncateText(text, limit) {
    if (text.length <= limit) return text;
    let truncated = text.substring(0, limit);
    const lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > 0) truncated = truncated.substring(0, lastSpace);
    return truncated + '...';
  }
  
  function initializeDescription() {
    const isMobile = window.innerWidth <= mobileBreakpoint;
    
    if (isMobile && textContent.length > mobileCharLimit) {
      // Mobile: Show truncated version with button
      const truncatedText = truncateText(textContent, mobileCharLimit);
      descriptionContent.innerHTML = '<p>' + truncatedText + '</p>';
      toggleBtn.textContent = t.showMore;
      toggleBtn.style.display = 'block';
      toggleBtn.style.visibility = 'visible';
      toggleBtn.classList.remove('desktop-hidden');
      isExpanded = false;
    } else {
      // Desktop: Always show full content, hide button completely
      descriptionContent.innerHTML = originalContent;
      toggleBtn.style.display = 'none';
      toggleBtn.style.visibility = 'hidden';
      toggleBtn.classList.add('desktop-hidden');
      isExpanded = true;
    }
  }
  
  function toggleDescription() {
    if (isExpanded) {
      const truncatedText = truncateText(textContent, mobileCharLimit);
      descriptionContent.innerHTML = '<p>' + truncatedText + '</p>';
      toggleBtn.textContent = t.showMore;
      isExpanded = false;
    } else {
      descriptionContent.innerHTML = originalContent;
      toggleBtn.textContent = t.showLess;
      isExpanded = true;
    }
  }
  
  toggleBtn.addEventListener('click', toggleDescription);
  
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initializeDescription, 250);
  });
  
  initializeDescription();
});